
import Vue from 'vue'
import NumberInput from '@/common/components/NumberInput.vue'
import RangeSlider from '@/common/components/RangeSlider.vue'
import { estimateSearchProducts } from '@/search/services'
import { MaxQuantityPrice  } from '@/common/types/maxQuantityPrice'
import { SYSTEM_ERROR } from '@/common/constants'
import { NUMBER_ITEM_PER_PAGE, DEFAULT_SORT_ORDER } from '@/search/const'

export default Vue.extend({
  components: {
    NumberInput,
    RangeSlider
  },
  props: {
    categoryId: {
      type: Number,
      required: true
    },
    searchTypeTitle: {
      type: String,
      required: true
    },
    maxQuantityPrice: {
      type: Object as () => MaxQuantityPrice,
      required: true
    }
  },
  data():{
    inputQuantity: number
    minRange: number
    maxRange: number
    minThreshold: number
    minInputValidate: boolean
    maxInputValidate: boolean
    expectResult: number

  } {
    return {
      inputQuantity: 0,
      minRange: 1,
      maxRange: 0,
      minThreshold: 1,
      minInputValidate: false,
      maxInputValidate: false,
      expectResult: 0
    }
  },
  computed: {
    maxThreshold(): number {
      return this.maxQuantityPrice.max_price
    },
    maxQuantityValue(): number {
      return this.maxQuantityPrice.max_quantity
    },
    resetCondition(): boolean {
      return this.minRange == this.minThreshold && this.maxRange == this.maxThreshold
    },
    errorMessage(): string {
      let error = ''
      if (this.maxThreshold){
        if (isNaN(this.maxRange) ||
          isNaN(this.minRange) ||  isNaN(this.inputQuantity)){
          error =  '半角数字で入力してください'
        } else if (this.minRange > this.maxRange ||
          this.maxRange < this.minRange ||
          this.minRange < this.minThreshold ||
          this.maxRange > this.maxThreshold ||
          this.validateInputForm){
          error =  '最小値は最大値より低いです。'
        }
      }
      return error
    },
    disableButton(): boolean {
      return this.errorMessage != '' || !this.expectResult
    },
    validateSearchInput(): boolean {
      return isNaN(this.minRange) || isNaN(this.maxRange) || isNaN(this.inputQuantity)
    },
    validateInputForm(): boolean {
      return (
        this.inputQuantity == 0 &&
        this.minInputValidate &&
        this.maxInputValidate
      )
    }
  },
  watch:{
    maxThreshold(value: number){
      this.maxRange = value
      this.estimateTotalItemsCount()
    }
  },
  created() {
    if (this.maxThreshold) {
      this.maxRange = this.maxThreshold
      this.estimateTotalItemsCount()
    }
  },
  methods: {
    closeModal() {
      this.$emit('closeModal')
    },
    inputValueHandler(value: number) {
      this.inputQuantity = value
      this.estimateTotalItemsCount()
    },
    rangeValuesHandler(value: { [key: string]: number }) {
      this.minRange = value.min
      this.maxRange = value.max
      this.estimateTotalItemsCount()
    },
    minInputValidateHandler(value: boolean) {
      this.minInputValidate = value
    },
    maxInputValidateHandler(value: boolean) {
      this.maxInputValidate = value
    },
    clearAllSearchParam() {
      this.inputQuantity = 0
      this.minRange = 1
      this.maxRange = this.maxThreshold
      this.estimateTotalItemsCount()
    },
    searchPayloadHandler(): {
      [key: string]: string | string[] | number | null
    } {
      return {
        categoryId: [`${this.categoryId}`],
        minUnitPrice: this.minRange,
        maxUnitPrice: this.maxRange,
        quantity:
          this.inputQuantity == 0 ? null : this.inputQuantity,
        facetValueNames: [],
        offset: 0,
        limit: NUMBER_ITEM_PER_PAGE,
        sortOrder: DEFAULT_SORT_ORDER
      }
    },
   async estimateTotalItemsCount() {
      const searchPayload = this.searchPayloadHandler()
      const searchPayloadValues = Object.values(searchPayload)
      if (this.validateSearchInput) return
      const { data } = await estimateSearchProducts(
        ...searchPayloadValues
      ).catch(() => {
        alert(SYSTEM_ERROR.UNKNOWN)
      })
      if (data) {
        this.expectResult = data?.skuSearch?.totalItemsCount
      }
    },
    goToSearchPage() {
      const searchPayload = this.searchPayloadHandler()
      location.href = `/search?category=${searchPayload.categoryId}&max=${searchPayload.maxUnitPrice}&min=${searchPayload.minUnitPrice}&quantity=${searchPayload.quantity}`
    }
  }
})
